import { Component } from 'react';

import ConversationList from '../ConversationList';
import MessageList from '../MessageList';

import './Messenger.css';
import { observer } from 'mobx-react';

class Messenger extends Component {
    render() {   
        return (
            <div className="messenger">
                <div className="scrollable chatsidebar">
                    <ConversationList {...this.props} />
                </div>

                <div className="scrollable content">
                    <MessageList {...this.props} />
                </div>
            </div>
        );
    }
}

export default observer(Messenger);
